<template>
  <div style="display: flex; flex-flow: column;">
    <div style="display: flex; justify-content: center; align-items: center">
      <el-upload
        class="avatar-uploader"
        multiple
        drag
        action=""
        :file-list="normal"
        :on-success="fnUploadSuccess"
        :headers="uploadHeaders"
        :show-file-list="true"
        :http-request="fnUploadRequest"
        :before-upload="beforeAvatarUpload"
        :limit="files"
      >
      </el-upload>
    </div>
    <div v-if="ifupload" style="display: flex;flex-flow: column; font-size: 10px;">
      <el-progress :percentage="uppercent" status="success"></el-progress>
      <div>上传文件：</div>
      <div>{{curfilename}} <i style="color: green;" class="el-icon-check"></i></div>
      <div>类型：{{curfiletype}} <i style="color: green;" class="el-icon-check"></i></div>
      <div>存储文件：</div>
      <div>{{finfilename}} <i style="color: green;" class="el-icon-check"></i></div>
      <div style="color: green;"><i class="el-icon-info">  状态：  {{fileupstate}} </i></div>
    </div>
  </div>
</template>

<script>
  import Utils from '../../util/utils'
  var OSS = require('ali-oss')
  export default {
    name: 'mfileUpload',
    props: {
      bucketpath: {
        type: String,
        required: true
      },
      curfilepath: {
        type: String,
        required: false
      },
      ifshowfile: {
        type: Boolean,
        required: false
      },
      ifimg: {
        type: Boolean,
        required: false
      },
      ifimgvideo: {
        type: Boolean,
        required: false
      },
      ifallfile: {
        type: Boolean,
        required: false
      }
    },
    data () {
      return {
        uploadUrl: '',
        uploadFileLength: 0,
        uploadFileSuccess: 0,
        uploadFileNames: [],
        uploadFileName: [],
        curfilename: '',
        curfiletype: '',
        finfilename: '',
        fileloadstate: '',
        normal: [],
        fileupstate: '等待上传',
        ifupload: false,
        fileList: [],
        files: 100,
        uploadHeaders: {
          authorization: ''
        },
        uppercent: 0,
        disabled: false
      }
    },
    mounted () {
      this.ifupload = false
      if (this.curfilepath !== '') {
        this.fileloadstate = '读取成功'
      } else {
        this.fileloadstate = '未设置'
      }
    },
    methods: {
      reset () {
        this.ifupload = false
      },
      randomString (num) {
        let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
        let res = ''
        for (let i = 0; i < num; i++) {
          var id = Math.ceil(Math.random() * 35)
          res += chars[id]
        }
        return res
      },
      beforeAvatarUpload (file) {
        var that = this
        if (this.ifimg) {
          window.console.log('只允许上传图片')
          if (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png') {
            that.ifupload = true
            that.ifshowfile = false
            that.fileupstate = '上传中...'
            return true
          } else {
            window.console.log('错误提示')
            this.$message({
              type: 'info',
              message: '当前只允许上传图片'
            })
            return false
          }
        } else if (this.ifimgvideo) {
          if (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'video/mp4') {
            that.ifupload = true
            that.ifshowfile = false
            that.fileupstate = '上传中...'
            return true
          } else {
            window.console.log('错误提示')
            this.$message({
              type: 'info',
              message: '当前只允许上传图片和视频'
            })
            return false
          }
        } else if (this.ifallfile){
          return true
        } else {
          return false
        }
      },
      /**
       * 创建oss客户端对象
       * @returns {*}
       */
      createOssClient () {
        return new Promise((resolve, reject) => {
          let client = new OSS({
            region: 'oss-cn-beijing',
            accessKeyId: 'LTAIaf73dyK72dHv',
            accessKeySecret: 'GRv2JMOvMC02F402r2ZHBElebVUB9v',
            bucket: 'sqtech'
          })
          resolve(client)
        })
      },
      /**
       * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
       * @author   yangxiaoshuo
       * @param    {object}   option [上传选项]
       * @return   {null}   [没有返回]
       */
      async fnUploadRequest (option) {
        var that = this
        let file = option.file
        const self = this
        return new Promise((resolve, reject) => {
          // let date = Utils.dateFormat(new Date(), 'yyyyMMdd') // 当前时间
          let dateTime = Utils.dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
          let randomStr = self.randomString(4)//  4位随机字符串
          that.curfilename = file.name
          let extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
          that.curfiletype = extensionName
          that.finfilename = dateTime + randomStr + extensionName
          let fileName = that.bucketpath + '/' + file.name // 文件名字（相对于根目录的路径 + 文件名）
          // 执行上传
          self.createOssClient().then(client => {
            // 异步上传,返回数据
            resolve({
              fileName: file.name,
              fileUrl: fileName
            })
            // 上传处理
            // 分片上传文件
            client.multipartUpload(fileName, file, {
              progress: function (p) {
                let e = {}
                e.percent = Math.floor(p * 100)
                // console.log('Progress: ' + p)
                option.onProgress(e)
                that.uppercent = e.percent
                console.log(e.percent)
              }
            }).then((val) => {
              if (val.res.statusCode === 200) {
                that.fileupstate = '上传完毕'
                option.onSuccess(val)
                return val
              } else {
                that.fileupstate = '上传失败'
                option.onError('上传失败')
              }
            }, err => {
              that.fileupstate = '上传失败'
              option.onError('上传失败')
              reject(err)
            })
          }).catch(errinfo => {
          })
        })
      },
      /**
       * @description [fnUploadSuccess 文件上传成功的函数]
       * @author   shanshuizinong
       * @return   {null}  [没有返回]
       */
      async fnUploadSuccess (res, file, fileList) {
        this.fileupstate = '上传完毕'
        window.console.log('多文件上传',res)
        if (this.ifallfile) {
          this.curfilepath = 'https://sqtech.oss-cn-beijing.aliyuncs.com/' + res.fileUrl
        }
        localStorage.setItem('upfileList',fileList)
        localStorage.setItem('curfilepath',this.curfilepath)
        if (res.fileUrl !== undefined && res.fileUrl !== 'undefined' && res.fileUrl !== null && res.fileUrl !== '') {
          this.$emit('upmok',this.curfilepath,fileList);
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/upload/MUpLoadFile.vue